/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BannerPriorityList200,
  GetApiV1BannerPriorityList401,
  GetApiV1BannerPriorityList500,
  GetApiV1BannerPriorityListQueryResponse,
} from "../../types/bannerRegistroController/GetApiV1BannerPriorityList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BannerPriorityList200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1BannerPriorityList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BannerPriorityList401Schema =
  z.any() as unknown as ToZod<GetApiV1BannerPriorityList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BannerPriorityList500Schema =
  z.any() as unknown as ToZod<GetApiV1BannerPriorityList500>;

export const getApiV1BannerPriorityListQueryResponseSchema = z.lazy(
  () => getApiV1BannerPriorityList200Schema,
) as unknown as ToZod<GetApiV1BannerPriorityListQueryResponse>;
